// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Textarea_inputWrapper__2gUp1","label":"Textarea_label__3Fmhv","input":"Textarea_input__2-OC4","number":"Textarea_number__2ivDT","text":"Textarea_text__18aWr"};